export default __webpack_public_path__ + "static/logo_black_square_large-17519c1ebc9b2e8205d8430d114e8c83.png";